export function Aggregates($http, loadWithCache, $timeout) {
  return {
    load: function (cubeName, filters, resetCache, canceler) {
      const requestUrl = filters.skipStat ?
        '/analytics/values/' + cubeName + '/' :
        '/analytics/aggregate/' + cubeName + '/';
      return loadWithCache(requestUrl,
        filters.buildQueryParams(), canceler, resetCache,
      )
        // delay response for debug
        // .then((result) => $timeout(50000).then(() => result))
        ;
    },
  };
}



// WEBPACK FOOTER //
// ./src/core/aggregate-resource.service.js